document.addEventListener('DOMContentLoaded', function() {

  const toMainProductInfo = document.getElementById('to-main-product-info');
  toMainProductInfo?.addEventListener('click', function(event) {
    event.preventDefault(); // Prevent the default behavior of the link
    const targetId = this.getAttribute('href').substring(1); // Get the target element's ID
    const targetElement = document.getElementById(targetId); // Get the target element

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth' // Apply smooth scrolling
      });
    }
  });


  const toMainProductInfoFixed = document.getElementById('to-main-product-info-fixed');

  window.setTimeout( function() {
    toMainProductInfoFixed.classList.remove('button--hidden')
  }, 1000)

  toMainProductInfoFixed.addEventListener('click', function(event) {
    event.preventDefault(); // Prevent the default behavior of the link
    const targetId = this.getAttribute('href').substring(1); // Get the target element's ID
    const targetElement = document.getElementById(targetId); // Get the target element

    if (!toMainProductInfoFixed.disabled) {
      const addToCardBtn = document.querySelector(".add-to-cart");

      addToCardBtn && addToCardBtn.click();
    }

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth' // Apply smooth scrolling
      });
    }
  });


 // Function to check if any part of an element is in the viewport
function isElementPartiallyInViewport(el) {
var rect = el.getBoundingClientRect();
return (
  rect.top <= window.innerHeight && rect.bottom >= 0 &&
  rect.left <= window.innerWidth && rect.right >= 0
);
}

// Function to add the "is-hidden" class to the button
function addIsHiddenClass() {
var toMainProductInfoButton = document.getElementById("to-main-product-info-fixed");
var productFormSubmitButtons = document.querySelectorAll(".product-form__submit");
var productHero = document.querySelector(".scroll-section");
var footer = document.querySelector(".footer");

var isProductHeroVisible = isElementPartiallyInViewport(productHero);
var isFooterVisible = isElementPartiallyInViewport(footer);
var isAnySubmitButtonVisible = false;


// Check if any part of a product form submit button is in the viewport
for (var i = 0; i < productFormSubmitButtons.length; i++) {
  if (isElementPartiallyInViewport(productFormSubmitButtons[i])) {
    isAnySubmitButtonVisible = true;
    break; // Exit the loop as soon as one button is in the viewport
  }
}

// Add or remove the "is-hidden" class based on conditions
if (isProductHeroVisible || isAnySubmitButtonVisible || isFooterVisible) {
  toMainProductInfoButton.classList.add("is-hidden");
} else {
  toMainProductInfoButton.classList.remove("is-hidden");
}
}

// Add a scroll event listener to check if the buttons are in the viewport
window.addEventListener("scroll", addIsHiddenClass);

// Initial check to see if the buttons are in the viewport when the page loads
window.addEventListener("load", addIsHiddenClass);
});

